import { produce } from 'immer'
import type { State } from '../../typings'
import type { SetActiveRequirementAction } from './action'

export const setActiveRequirementProducer = produce<
  State,
  [SetActiveRequirementAction['payload']]
>((draft, payload) => {
  draft.transition = !payload || !draft.activeRequirement
  draft.activeRequirement = payload
})
